<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：Copyright
 *
 * 作成者：2022/01/07 ノア）虞
 * 最終修正者：2022/01/07 ノア）虞
 *
 -->
<template>
  <svg
    :class="svgClass"
    :style="{ fill: iconColor, width: width + 'px', height: height + 'px' }"
    aria-hidden="true"
    v-on="$listeners"
  >
    <use :xlink:href="svgIconName" />
  </svg>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'ttiSvgIcon'
})
export default class TtiSvgIcon extends Vue {
  /**
   * アイコン名
   */
  @Prop({
    required: true
  })
  iconName!: string

  /**
   * スタイルクラス
   */
  @Prop({
    default: ''
  })
  className?: string

  @Prop({
    default: 24
  })
  width?: number

  @Prop({
    default: 24
  })
  height?: number

  @Prop({
    default: 'currentColor'
  })
  iconColor?: string

  /**
   * アイコン名
   *
   * @returns {string} アイコン名
   */
  get svgIconName(): string {
    return `#icon-${this.iconName}`
  }

  /**
   * スタイルクラス
   *
   * @returns {string} スタイルクラス
   */
  get svgClass(): string {
    if (this.className) {
      return 'svg-icon ' + this.className
    } else {
      return 'svg-icon'
    }
  }
}
</script>

<style scoped lang="scss">
.svg-icon {
  width: 24px;
  height: 24px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
